import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as SonicSense } from '@styles/icons/sonicSense.svg';
import React from 'react';

export const SonicSensIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={SonicSense} viewBox={'0 0 19 21'} />
);

export default SonicSensIcon;
